import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { MenuDish } from '../constants/type.constant';
import { allergen as getAllergenPic, getDishIdentsDark, preLoadNginxImage } from '../tools/utils';
import _ from 'lodash';
import Store from '../redux/store';
import { StateManager } from '../redux/stateManager';
import { GuideTooltips } from './tooltip.component';
import i18n from '../i18n';
import { WebsocketClient } from '../websocket/module';
import foodDefaultImage from '../assets/food.png';
import RestoreOutlinedIcon from '@material-ui/icons/RestoreOutlined';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import ServerShoppingCart from '../modules/server-shopping-cart';
const bargainIcon = require('../assets/bargain-icons/QOP-normal-bargain-icon.png');
const allergenFilterIcon = require('../assets/allergen-filter-icon/QOP-normal-allergen-filter-icon.png');

// 加入或移出购物车
enum UPGRADE {
    REMOVE_DISH = -1,
    ADD_DISH = 1,
}

// 菜品组件(列表模式)
class NormalDish extends React.Component<Props, State>{

    public async UNSAFE_componentWillMount() {

        const findRes = this.getSettingInfoValue('show-item-name1-or-item-name2')
        if (findRes) this.isShowName1 = findRes.value.showItemName1;
        // 预加载图片
        await this.preloadImage();

    }
    public state: State = {
        // 用于componentDidMount钩子完成后判断
        setNodeDone: false,
        guidePageHideCard: false,
        dishImg: '',
        item: this.props.item,
        foodHeight: '',
    };
    public componentDidMount() {
        // $ 监听新手引导 （菜单页）关闭
        WebsocketClient.addListener('GUIDE_DISH_UPDATE', this.guideDishUpdate);
    }
    public componentWillUnmount() {
        // $ 移除监听
        WebsocketClient.removeListener('GUIDE_DISH_UPDATE', this.guideDishUpdate);
    }
    // *********************
    // 方法区
    // *********************
    public isShowName1 = true;
    public getSettingInfoValue(str: string) {
        const SETTING = StateManager.getFromCache('settingInfo');
        return _.find(SETTING, ['name', str]);
    }

    /**
     * 预加载图片
     * - 1：先加载菜品图片
     *   - 成功就显示本身
     *   - 失败就显示用户默认图片，步骤2
     * - 2：加载用户设置的默认图片
     *   - 成功就显示
     *   - 失败就显示本地默认图片
     */
    async preloadImage() {
        let dishImg = `${Store.getState().serverUrl}/menu_pic/${this.props.item?.item_id}_s.jpg`;
        const newImage = await  preLoadNginxImage(dishImg, '/menu_pic', '', true);
        this.setState({
            dishImg: newImage || foodDefaultImage
        })
    }

    /**
     *  $ 监听通讯事件
     */
    // 监听新手引导（菜单页）关闭后执行卡片气泡提示
    public guideDishUpdate = () => {
        this.setState({
            guidePageHideCard: true
        })
    }

    // *********************
    // 视图区
    // *********************
    public render() {
        const { item, changeMenuQuantity, openMenuDetail, eIndex, showTip, cacheGuidePageHideCard, currency_name } = this.props;
        // 菜品名称
        let foodName = this.isShowName1 ? item.item_name1 : item.item_name2;
        // 菜品描述
        let desc = _.get(item, 'item_description', '');
        let extDishInfo = _.get(item, 'ext_dish_info', '');

        //  这个模式不需要 显示历史数量 + 当前数量
        const quantity = item.quantity || 0;
        // 历史数量
        const historyQuantity = item.history_num || 0;
        // 套餐
        const isSetMenu = item.item_type === 3;
        // isBusinessTime 为true则不在营业时间内
        const isBusinessTime = Store.getState().isBusinessTime;
        // 菜品标识数组
        const dishIdentsArrs = (item.other_detail_info || []).slice(0, 4);
        // 过敏原 & 菜品标识过滤器标识
        const filterFlag: boolean = ServerShoppingCart.getAllergensAndIngredentsFilterFlag(item);
        // 是否为沽清菜品
        const isBargainDish = [1, 3].includes(Number(item.bargain_stype)) || (Number(item.bargain_stype) === 2 && typeof(item.bargain_num_cur) !== 'number');
        // 是否为数量沽清菜品
        const isNumBargainDish = (Number(item.bargain_stype) === 2 && typeof(item.bargain_num_cur) === 'number');
        return (
            <React.Fragment>
                {
                    <Grid item xs={6} key={eIndex}>
                        <div className={`dishBox ${item.quantity > 0 && !isSetMenu ? 'box active' : 'box'}`}  >

                            {/* 曾经点过菜 */}
                            {
                                historyQuantity
                                    ? <div className='normal-dish-history-order-icon-box'>
                                        <RestoreOutlinedIcon className='history-order-icon' />
                                    </div> : null
                            }
                            {/* 菜品沽清 */}
                            {
                                (isBargainDish || filterFlag) ?
                                <div className='bargainStype' onClick={() => { openMenuDetail(eIndex) }}>
                                    {
                                        isBargainDish ? 
                                            <div className='mask-icon-box'>
                                                {/* <RoomServiceIcon />
                                                <CloseIcon className=' bargain-icon' /> */}
                                                <img src={bargainIcon} />
                                            </div>
                                            :
                                            null
                                    }
                                    {filterFlag && <div className='mask-icon-box'><img src={allergenFilterIcon} style={{ width: 40, height: 40 }} /></div>}
                                </div>
                                :
                                null
                            }                
                            <div
                                className={"top"} id={`top${eIndex}`}
                            >
                                {/* 营业时间规则的限制 */}
                                {
                                    isBusinessTime && item.not_joining_global_limit !== 1 &&
                                    <div className='businessTimeStype'></div>
                                }
                                <div className="left">
                                    <div className="leftTop">
                                        <h3 className="title">
                                            {foodName}
                                            {/* <span className={`${item.other_detail_info.length > 0 ? 'star' : 'hide'}`}>*</span> */}
                                        </h3>

                                    </div>
                                    {
                                        (_.trim(`${desc}`).length > 0 || _.trim(`${extDishInfo}`).length > 0) &&
                                        <p className="desc">{extDishInfo} {desc}</p>
                                    }
                                    <div className="right">
                                        {item.price_1.toFixed(2)} {currency_name}
                                        <div className='dish-idents-box'>
                                            {
                                                dishIdentsArrs.map((odItem, index2) => (
                                                    <>
                                                        {
                                                            index2 > 2 ?
                                                                <MoreHorizIcon className='dish-ident-omit-icon' />
                                                                :
                                                                <img className='dish-ident-img' src={getDishIdentsDark(odItem)} alt={odItem} key={index2} />
                                                        }
                                                    </>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={`${cacheGuidePageHideCard && this.state.guidePageHideCard ? "bottom guideBottom" : "bottom"} ${this.state.dishImg ? 'animate-fadeIn' : 'MuiSkeleton-wave '}`}
                                style={{ backgroundImage: `url(${this.state.dishImg})`, flex: 1 }}
                                onClick={() => openMenuDetail(eIndex)}>
                                {/* 数量沽清标识 */}
                                {isNumBargainDish ? 
                                    <div className={`set-menu-bargain-icon-box ${item.allergen?.length > 0 ? 'set-menu-bargain-allergen-icon-box' : ''}`} style={{ borderRadius: 0 }}>
                                        {
                                            item.quantity > 0 ?
                                            <div className='bargain-badge-box'>
                                                <img className='bargain-badge-icon' src={bargainIcon} />
                                                <div className={`text ${item.quantity > 0 ? 'active' : 'not-active'}`} style={{ marginLeft: 5 }}>
                                                {`${item.quantity}`}
                                                </div>
                                                <div className={`text ${item.quantity > 0 ? 'active_3' : ''}`}>
                                                    {`/${item.bargain_num_cur}`}
                                                </div>                                                                                                                                                                          
                                            </div>
                                            :
                                            <img className='bargain-badge-icon' src={bargainIcon} />
                                        }
                                    </div>
                                    :
                                    null
                                }
                                {/* 套餐标识 */}
                                {isSetMenu && <div className='set-menu-icon-box-normal'>{i18n.t('menu_page_text_setMenu')}</div>}
                                <div className="buttonImg">
                                    <div>{
                                        item.allergen.filter((item, index1) => {
                                            return (index1 < 5)
                                        }).map((allergyItem, index) => (
                                            <>
                                                {
                                                    index > 3 ?
                                                        <MoreHorizIcon className='allerrgen-omit-icon' />
                                                        :
                                                        <img src={getAllergenPic(allergyItem)} alt={allergyItem} key={index} />
                                                }
                                            </>
                                        ))
                                    }
                                    </div>

                                </div>
                                {(showTip && eIndex === 0) &&
                                    <GuideTooltips
                                        placement="top"
                                        arrow
                                        open={cacheGuidePageHideCard}
                                        title={i18n.t('novice_guide_text_enlarge_dish_card')}
                                        toopTipStyle={{
                                            popperIndex: this.state.guidePageHideCard,
                                            backgroundColor: '#eff07b',
                                            height: 35
                                        }}
                                    >
                                        <div className="placeholder-box">{/* 占位盒 */}</div>
                                    </GuideTooltips>}
                            </div>
                            {/* 区分精简版和普通版 */}
                            {
                                this.props.liteMode ?
                                    <Grid
                                        container
                                        spacing={0}
                                        style={{ background: '#fff' }} >
                                        <Grid item xs={4}><RemoveIcon ></RemoveIcon></Grid>
                                    </Grid> :
                                    (isSetMenu ?
                                        <Grid
                                            container
                                            spacing={0}
                                            className="footer"
                                            style={(isBusinessTime && item.not_joining_global_limit !== 1) ? { background: '#007993' } : {}}>
                                            <Grid item xs={12} >
                                                <Button
                                                    fullWidth
                                                    className="icon alignLeft"
                                                    onClick={() => {
                                                        this.props?.openSetDishDetail?.(eIndex);
                                                    }}
                                                // disabled={item.quantity === 0}
                                                >
                                                    {/* // TODO 国际化 */}
                                                    {i18n.t('Order')}
                                                </Button>
                                            </Grid>
                                        </Grid> :
                                        <Grid
                                            container
                                            spacing={0}
                                            className={"footer"}
                                            style={(isBusinessTime && item.not_joining_global_limit !== 1) ? { background: '#007993' } : {}}>
                                            <Grid item xs={4}
                                                className={cacheGuidePageHideCard && this.state.guidePageHideCard ? "footer guideFooter" : ""}
                                            >
                                                {(showTip && eIndex === 0) && <GuideTooltips
                                                    placement="bottom"
                                                    arrow
                                                    open={cacheGuidePageHideCard}
                                                    title={i18n.t('novice_guide_text_reduce_order')}
                                                    toopTipStyle={{
                                                        popperIndex: this.state.guidePageHideCard,
                                                        height: 35
                                                    }}
                                                >
                                                    <div className="placeholder-top-box" style={{ display: cacheGuidePageHideCard ? 'block' : 'none' }}></div>
                                                </GuideTooltips>}
                                                <Button
                                                    fullWidth
                                                    className="icon alignLeft"
                                                    onClick={() => {
                                                        // let tempDishes = ShoppingCart.metaData[ShoppingCart.globalRound][customer];
                                                        // let lastDish = _.findLast(tempDishes, (n) => {
                                                        //     return n._origin.item_id === item.item_id
                                                        // })

                                                        // if (lastDish) {
                                                        //     this.props.changeMenuQuantity(lastDish?._origin as MenuDish, UPGRADE.REMOVE_DISH, item)
                                                        // } else {
                                                        this.props.changeMenuQuantity(item, UPGRADE.REMOVE_DISH)
                                                        // }
                                                    }}
                                                    disabled={item.quantity === 0}
                                                >
                                                    <RemoveIcon></RemoveIcon>
                                                </Button>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="num" style={{ fontSize: '18px' }}>
                                                    {/* {Store.getState().isShowTime ? item.quantity + (item.history_num || 0) : item.quantity} */}
                                                    {/* 当前数量 */}
                                                    {quantity + historyQuantity}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}
                                                className={cacheGuidePageHideCard && this.state.guidePageHideCard ? "footer guideFooter" : ""}
                                            >
                                                {(showTip && eIndex === 0) && <GuideTooltips
                                                    onClose={() => {
                                                    }}
                                                    placement="bottom"
                                                    arrow
                                                    open={cacheGuidePageHideCard}
                                                    title={i18n.t('novice_guide_text_increase_order')}
                                                    toopTipStyle={{
                                                        popperIndex: this.state.guidePageHideCard,
                                                        height: 35
                                                    }}
                                                >
                                                    <div className="placeholder-top-box" style={{ display: cacheGuidePageHideCard ? 'block' : 'none' }}></div>
                                                </GuideTooltips>}
                                                <Button
                                                    fullWidth
                                                    className="icon alignRight"
                                                    onClick={() => {
                                                        // 营业时间规则的限制
                                                        const isDish = isBusinessTime && item.not_joining_global_limit !== 1
                                                        !isDish && changeMenuQuantity(item, UPGRADE.ADD_DISH)
                                                    }}
                                                >
                                                    <AddIcon></AddIcon>
                                                </Button>
                                            </Grid>
                                        </Grid>)
                            }
                        </div>
                    </Grid >
                }
            </React.Fragment>
        )
    }
}
export default NormalDish

type Props = {
    item: MenuDish & {
        history_num?: number | undefined;
    }
    // 当前菜品下标
    eIndex: number;
    dishActive?: boolean;
    /**
     * 更新购物车
     * @param dish 菜品数据`Dish`
     * @param type 操作类型` UPGRADE_OPERATES`
     */
    changeMenuQuantity(dish: MenuDish, type: UPGRADE, expandDish?: MenuDish): void
    /**
     * 打开菜品大图
     * @param initialSlide 初始化时slide的索引
     */
    openMenuDetail(initialSlide: number): void
    customer: string
    // 精简版模式
    liteMode?: boolean;
    // 显示引导层
    showTip?: boolean;
    // 引导层
    cacheGuidePageHideCard: boolean;
    // 打开套餐详情弹窗
    openSetDishDetail?(initialSlide: number): void;
    // 货币文本
    currency_name: string;
}

type State = {
    setNodeDone: boolean;
    guidePageHideCard: boolean;
    dishImg: string;
    item: MenuDish & {
        history_num?: number | undefined;
    }
    foodHeight: string;
}